export { default as Ad } from './AdContainer';
